import React from "react";
import WindowPattern from "./patterns/PatternSelector";

const BowDiagram = ({
  selectedValue,
  availableOptions,
  onChange,
  mode,
  disabled,
  formData,
  allAvailableOptions,
}) => {
  // Find options based on mode
  const endLitesOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("end lites"),
  );
  const OneThreeFiveLitesOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("1-3-5"),
  );
  const allLitesOption = availableOptions?.find((opt) =>
    opt.name.toLowerCase().includes("all lites"),
  );
  const fullWindowOption =
    availableOptions?.find(
      (opt) =>
        !opt.name.toLowerCase().includes("sash") &&
        !opt.name.toLowerCase().includes("lite"),
    ) || availableOptions?.[0];

  // Determine which sections should show pattern
  const getSelectedSections = () => {
    if (mode === "grid") {
      if (selectedValue === endLitesOption?.id) {
        return [true, false, false, false, true]; // sections 1 and 5
      } else if (selectedValue === OneThreeFiveLitesOption?.id) {
        return [true, false, true, false, true]; // sections 1, 3, and 5
      } else if (selectedValue === allLitesOption?.id) {
        return [true, true, true, true, true]; // all sections
      }
    } else if (mode === "obscurity") {
      // For obscurity, if selected, all panels are obscured
      if (selectedValue) {
        return [true, true, true, true, true]; // all sections
      }
    }
    return [false, false, false, false, false]; // none
  };

  const selectedSections = getSelectedSections();

  const handleClick = () => {
    if (disabled || mode === "display") return;

    if (mode === "grid") {
      // Cycle through: null/other → End Lites → 1-3-5 Lites → All Lites → null
      if (
        !selectedValue ||
        (selectedValue !== endLitesOption?.id &&
          selectedValue !== OneThreeFiveLitesOption?.id &&
          selectedValue !== allLitesOption?.id)
      ) {
        onChange(endLitesOption?.id);
      } else if (selectedValue === endLitesOption?.id) {
        onChange(OneThreeFiveLitesOption?.id);
      } else if (selectedValue === OneThreeFiveLitesOption?.id) {
        onChange(allLitesOption?.id);
      } else if (selectedValue === allLitesOption?.id) {
        onChange(null);
      }
    } else if (mode === "obscurity") {
      // Simple toggle for obscurity
      onChange(selectedValue ? null : fullWindowOption?.id);
    }
  };

  // Get grid style name for pattern
  const selectedGridStyle = allAvailableOptions?.grid_styles?.find(
    (style) => style.id === formData?.grid_style_id,
  );

  return (
    <div className="flex justify-center items-center">
      <div
        className="flex relative"
        style={{
          perspective: "1000px",
          perspectiveOrigin: "center -20%",
        }}
        onClick={handleClick}
      >
        <div
          className={`relative w-20 h-60 border-8 border-brand bg-light border-r-0
                  ${disabled ? "opacity-50" : ""}`}
          style={{
            transform: "rotateY(-30deg) translateZ(-40px) translateX(-12px)",
            transformStyle: "preserve-3d",
          }}
        >
          <WindowPattern
            mode={mode}
            isSelected={selectedSections[0]}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>
        <div
          className={`relative w-20 h-60 border-8 border-brand bg-light border-r-0
                  ${disabled ? "opacity-50" : ""}`}
          style={{
            transform: "rotateY(-15deg) translateZ(-10px)",
            transformStyle: "preserve-3d",
          }}
        >
          <WindowPattern
            mode={mode}
            isSelected={selectedSections[1]}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>
        <div
          className={`relative w-20 h-60 border-8 border-brand bg-light flex
                  items-center justify-center text-white font-medium text-sm text-center px-2
                  ${disabled ? "opacity-50" : ""}`}
          style={{
            transformStyle: "preserve-3d",
          }}
        >
          <WindowPattern
            mode={mode}
            isSelected={selectedSections[2]}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>
        <div
          className={`relative w-20 h-60 border-8 border-brand bg-light border-l-0
                  ${disabled ? "opacity-50" : ""}`}
          style={{
            transform: "rotateY(15deg) translateZ(-10px)",
            transformStyle: "preserve-3d",
          }}
        >
          <WindowPattern
            mode={mode}
            isSelected={selectedSections[3]}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>
        <div
          className={`relative w-20 h-60 border-8 border-brand bg-light border-l-0
                  ${disabled ? "opacity-50" : ""}`}
          style={{
            transform: "rotateY(30deg) translateZ(-40px) translateX(12px)",
            transformStyle: "preserve-3d",
          }}
        >
          <WindowPattern
            mode={mode}
            isSelected={selectedSections[4]}
            gridStyleName={selectedGridStyle?.name}
          />
        </div>
      </div>
    </div>
  );
};

export default BowDiagram;
